import {
  View,
  Text,
  Image,
  Keyboard,
  TextInput,
  FlatList,
  TouchableOpacity,
  ScrollView,
} from "react-native";
import React, { useEffect, useState } from "react";
import {
  DrawerActions,
  StackActions,
  useNavigation,
} from "@react-navigation/native";
import {
  useDeviceSize,
  CreateResponsiveStyle,
  DEVICE_SIZES,
} from "rn-responsive-styles";
import { AppColors } from "../../../utility/AppColors";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppImages } from "../../../utility/AppImages";
import { getLoginData } from "../../../utility/AppStoreData";
import { toast } from "react-toastify";
import DateTimePickerModal from "./Common/DateTimePickerModal";
import dayjs from "dayjs";
import PurchaseSuccess from "./PurchaseSuccess";
import * as ImagePicker from "expo-image-picker";
import VerificationModal from "./VerificationModal";
import { ShowLoader } from "../../../common/ShowLoader";
import { base_url, endpoints } from "../../../Api/configs";
import { Dimensions } from "react-native";
import { fetchPaymentRequestRefund } from "../../../services/profileAPI";
import { ScreenBGGradientView } from "../../../common/CommonView";

const RefundRequestScreen = ({ route }) => {
  const routeData = route.params;
  const navigation = useNavigation();
  const styles = useStyles();
  const deviceSize = useDeviceSize();

  const [userData, setUserData] = useState(null);

  const [explainReason, setExplainReason] = useState("");
  const [eventName, setEventName] = useState("");
  const [amount, setAmount] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");

  const [selectDateTimePressed, setSelectDateTimePressed] = useState(true); // True = select date , false = select time
  const [dateTimeInput, setDateTimeInput] = useState("");
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectDate, setSelectDate] = useState("");
  const [selectTime, setSelectTime] = useState("");

  const [showPurchaseSuccess, setShowPurchaseSuccess] = useState(false);
  const [showVerification, setShowVerification] = useState(false);
  const [image, setImage] = useState(null);

  const [showLoader, setShowLoader] = useState(false);

  const [arrSelectReason, setArrSelectReason] = useState([
    { id: 1, reason: "Cancelled Event", isSelected: true },
    { id: 2, reason: "Change of Plan", isSelected: false },
    { id: 3, reason: "Technical Issues", isSelected: false },
    { id: 4, reason: "Other", isSelected: false },
  ]);

  const [arrRefundMethod, setArrRefundMethod] = useState([
    { id: 1, method: "Credit Card", isSelected: true },
    { id: 2, method: "Debit Card", isSelected: false },
    { id: 3, method: "Paypal", isSelected: false },
    { id: 4, method: "Google Pay", isSelected: false },
  ]);

  useEffect(() => {
    getLoginUserData();
  }, []);

  async function getLoginUserData() {
    const data = await getLoginData();

    if (data != null) {
      setUserData(data);
    }
  }

  const pickImage = async () => {
    // No permissions request is necessary for launching the image library
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsEditing: true,
      aspect: [4, 3],
      quality: 1,
    });

    if (!result.canceled) {
      setImage(result.assets[0].uri);
    }
  };
  const [isLargeScreen, setIsLargeScreen] = useState(true);

  // useEffect(() => {
  //     const updateLayout = () => {
  //         const { width } = Dimensions.get('window');
  //         setIsLargeScreen(width >= 600); // Adjust the width threshold as needed
  //     };

  //     updateLayout();
  //     Dimensions.addEventListener('change', updateLayout);

  //     return () => {
  //         Dimensions.removeEventListener('change', updateLayout);
  //     };
  // }, []);

  const renderButtons = () => {
    return arrSelectReason.map((item, index) => (
      <TouchableOpacity
        key={index}
        style={{
          borderRadius: 10,

          height: 66,
          alignItems: "center",
          flexDirection: "row",
          paddingHorizontal: 30,
          backgroundColor: item.isSelected
            ? AppColors.grayColor_505050
            : AppColors.appBlackColor_1e1e1e,
          gap: 8,
          borderColor: AppColors.appViolentColor_6D08C3,
          borderWidth: item.isSelected ? 1 : 0,
          marginVertical:
            deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 0 : 5,
          width:
            deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? "auto" : "45%",
        }}
        onPress={() => {
          let tempArr = [...arrSelectReason];
          tempArr.map((item, idx) => {
            item.isSelected = false;
          });
          tempArr[index].isSelected = true;
          setArrSelectReason(tempArr);
        }}
      >
        <View
          style={{
            height: 18,
            width: 18,
            borderRadius: 9,
            borderColor: AppColors.appViolentColor_6D08C3,
            borderWidth: 1,
            backgroundColor: item.isSelected
              ? AppColors.appViolentColor_6D08C3
              : "transparent",
          }}
        />
        <Text
          style={[AppFontStyle.REGULAR_ANYBODY_16, { color: AppColors.white }]}
        >
          {item.reason}
        </Text>
      </TouchableOpacity>
    ));
  };

  const renderButtonMethods = () => {
    return arrRefundMethod.map((item, index) => (
      <TouchableOpacity
        key={index}
        style={{
          borderRadius: 10,
          height: 66,
          alignItems: "center",
          // justifyContent: 'center',
          flexDirection: "row",
          paddingHorizontal: 30,
          backgroundColor: item.isSelected
            ? AppColors.grayColor_505050
            : AppColors.appBlackColor_1e1e1e,
          gap: 8,
          borderColor: AppColors.appViolentColor_6D08C3,
          borderWidth: item.isSelected ? 1 : 0,
          marginVertical:
            deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 0 : 5,
          width:
            deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? "auto" : "45%",
        }}
        onPress={() => {
          let tempArr = [...arrRefundMethod];
          tempArr.map((item, index) => {
            item.isSelected = false;
          });
          tempArr[index].isSelected = true;
          setArrRefundMethod(tempArr);
        }}
      >
        <View
          style={{
            height: 18,
            width: 18,
            borderRadius: 9,
            borderColor: AppColors.appViolentColor_6D08C3,
            borderWidth: 1,
            backgroundColor: item.isSelected
              ? AppColors.appViolentColor_6D08C3
              : "transparent",
          }}
        />
        <Text
          style={[AppFontStyle.REGULAR_ANYBODY_16, { color: AppColors.white }]}
        >
          {item.method}
        </Text>
      </TouchableOpacity>
    ));
  };

  return (
    <View style={[styles.container]}>
      <ScreenBGGradientView />
      <View
        style={{
          // backgroundColor: AppColors.bgBlueColor_1B0D38,
          height: "7%",
          width: "100%",
          flexDirection: "row",
          justifyContent: "space-between",
          paddingHorizontal: 8,
        }}
      >
        <Text
          style={[
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? AppFontStyle.BOLD_ANYBODY_20
              : AppFontStyle.BOLD_ANYBODY_32,
            {
              color: AppColors.white,
              alignItems: "center",
              justifyContent: "center",
              alignSelf: "center",
            },
          ]}
        >
          Refund Request
        </Text>
        <View
          style={{
            justifyContent: "center",
            flexDirection: "row",
            alignItems: "center",
            gap: 10,
          }}
        >
          <Text
            style={[
              AppFontStyle.BOLD_ANYBODY_14,
              {
                color: AppColors.white,
                alignItems: "center",
                justifyContent: "center",
                alignSelf: "center",
              },
            ]}
          >
            {userData != null ? userData.username : ""}
          </Text>

          <View
            style={{
              // margin: '8%',
              height: "80%",
              aspectRatio: 1,
              backgroundColor: AppColors.appViolentColor_6D08C3,
              borderRadius: 100,
            }}
          ></View>
        </View>
      </View>

      <ScrollView contentContainerStyle={{ paddingHorizontal: 8 }}>
        <View
          style={{
            width:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? "100%"
                : "80%",
          }}
        >
          {/* Separater */}
          <View style={styles.separaterStyle} />

          {/* Select Reason* */}
          <View>
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_14,
                { color: AppColors.white, marginBottom: 15 },
              ]}
            >
              Select Reason*
            </Text>
            <View
              style={{
                flexDirection: "row",
                flexWrap: "wrap",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {renderButtons()}
            </View>
          </View>

          {/* Explain the reason*/}
          <View style={[styles.deviceflexDirection, { columnGap: 20 }]}>
            {/* Explain the reason*/}
            <View style={{ gap: 8, flex: 1, marginTop: 20 }}>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_12,
                  { color: AppColors.gray_C3C3C3 },
                ]}
              >
                Explain the reason*
              </Text>
              <TextInput
                style={[
                  styles.textInputStyle,
                  { height: 105, width: "100%", flex: 1 },
                ]}
                placeholder="Details section to explain the reason"
                placeholderTextColor={AppColors.gray_C3C3C3}
                verticalAlign="top"
                multiline={true}
                value={explainReason}
                onChangeText={(text) => {
                  setExplainReason(text);
                }}
              />
            </View>

            {/* Attached Screenshot */}
            <View style={[{ gap: 8, flex: 1, marginTop: 20 }]}>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_12,
                  { color: AppColors.gray_C3C3C3 },
                ]}
              >
                Attached Screenshot
              </Text>
              <View style={styles.dragDropView}>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 15,
                  }}
                >
                  <Image
                    source={AppImages.icDragNDrop}
                    style={{ height: 40, width: 40, resizeMode: "contain" }}
                  />
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      { color: AppColors.gray_C3C3C3, flexWrap: "wrap" },
                    ]}
                    numberOfLines={3}
                  >
                    Drag & drop file here
                  </Text>
                </View>
                <TouchableOpacity
                  style={{
                    paddingHorizontal: 50,
                    backgroundColor: AppColors.appViolentColor_6D08C3,
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: 10,
                    paddingVertical: 10,
                  }}
                  onPress={() => {
                    pickImage();
                  }}
                >
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      { color: AppColors.white },
                    ]}
                  >
                    Browse
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>

          {/* Separater */}
          <View style={styles.separaterStyle} />

          {/* Refund Method* */}
          <View>
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_14,
                { color: AppColors.white, marginBottom: 15 },
              ]}
            >
              Refund Method*
            </Text>
            <View
              style={{
                flexDirection: "row",
                flexWrap: "wrap",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {renderButtonMethods()}
            </View>
          </View>

          {/* Separater */}
          <View style={styles.separaterStyle} />

          {/*Event Details */}
          <View style={{}}>
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_14,
                { color: AppColors.white, marginBottom: 15 },
              ]}
            >
              Event Details
            </Text>

            <View style={styles.infoViewStyle}>
              {/* Event name */}
              <View style={{ gap: 8, flex: 1 }}>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_12,
                    { color: AppColors.gray_C3C3C3 },
                  ]}
                >
                  Event name
                </Text>
                <TextInput
                  style={styles.textInputStyle}
                  placeholder="My new streaming"
                  placeholderTextColor={AppColors.gray_C3C3C3}
                  value={eventName}
                  onChangeText={(text) => {
                    setEventName(text);
                  }}
                />
              </View>

              {/* Enter Amount */}
              <View style={{ gap: 8, flex: 1 }}>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_12,
                    { color: AppColors.gray_C3C3C3 },
                  ]}
                >
                  Enter Amount
                </Text>
                <TextInput
                  style={styles.textInputStyle}
                  placeholder="$34"
                  placeholderTextColor={AppColors.gray_C3C3C3}
                  value={amount}
                  onChangeText={(text) => {
                    setAmount(text);
                  }}
                />
              </View>
            </View>
          </View>

          {/* Separater */}
          <View style={styles.separaterStyle} />

          {/* Contact Information */}
          <View>
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_14,
                { color: AppColors.white, marginBottom: 15 },
              ]}
            >
              Contact Information
            </Text>

            <View style={styles.infoViewStyle}>
              {/* Phone number */}
              <View style={{ gap: 8, flex: 1 }}>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_12,
                    { color: AppColors.gray_C3C3C3 },
                  ]}
                >
                  Phone number
                </Text>
                <TextInput
                  style={styles.textInputStyle}
                  placeholder="+52 543 4564 4543"
                  placeholderTextColor={AppColors.gray_C3C3C3}
                  value={phone}
                  onChangeText={(text) => {
                    setPhone(text.replace(/[^0-9]/g, ""));
                  }}
                />
              </View>

              {/* Email */}
              <View style={{ gap: 8, flex: 1 }}>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_12,
                    { color: AppColors.gray_C3C3C3 },
                  ]}
                >
                  Email
                </Text>
                <TextInput
                  style={styles.textInputStyle}
                  textAlign={"center"}
                  placeholder="example@gmail.com"
                  placeholderTextColor={AppColors.gray_C3C3C3}
                  value={email}
                  onChangeText={(text) => {
                    setEmail(text);
                  }}
                />
              </View>
            </View>
          </View>

          {/* Separater */}
          <View style={styles.separaterStyle} />

          {/* Event date and time */}
          <View style={{ marginBottom: 20 }}>
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_14,
                { color: AppColors.white, marginBottom: 15 },
              ]}
            >
              Event date and time
            </Text>

            <View style={styles.infoViewStyle}>
              {/* Select date */}
              <View style={{ gap: 8, flex: 1 }}>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_12,
                    { color: AppColors.gray_C3C3C3 },
                  ]}
                >
                  Select date
                </Text>
                <View
                  style={{
                    justifyContent: "center",
                    flex: 1,
                  }}
                >
                  <TouchableOpacity
                    style={[]}
                    onPress={() => {
                      setShowDatePicker(true);
                      setSelectDateTimePressed(true);
                    }}
                    activeOpacity={0.9}
                  >
                    <Image
                      source={AppImages.icDateCalendar}
                      style={{
                        height: 22,
                        width: 22,
                        position: "absolute",
                        right: 16,
                        marginVertical: 9,
                      }}
                    />

                    <TextInput
                      placeholder={"Select Date"}
                      multiline={false}
                      placeholderTextColor={AppColors.gray_C3C3C3}
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        styles.textInputStyle,
                      ]}
                      editable={false}
                      // ref={refValue}
                      onSubmitEditing={() => {}}
                      onChangeText={setSelectDate}
                      keyboardType="default"
                      secureTextEntry={false}
                      value={selectDate}
                    />
                  </TouchableOpacity>
                </View>
              </View>

              {/* Select time */}
              <View style={{ gap: 8, flex: 1 }}>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_12,
                    { color: AppColors.gray_C3C3C3 },
                  ]}
                >
                  Select time
                </Text>
                <View
                  style={{
                    justifyContent: "center",
                    flex: 1,
                  }}
                >
                  <TouchableOpacity
                    style={[styles.inputWrapper]}
                    onPress={() => {
                      setShowDatePicker(true);
                      setSelectDateTimePressed(false);
                    }}
                    activeOpacity={0.9}
                  >
                    <Image
                      source={AppImages.icTopDownArrow}
                      style={{
                        height: 22,
                        width: 22,
                        position: "absolute",
                        right: 16,
                        marginVertical: 9,
                        resizeMode: "contain",
                      }}
                    />
                    <TextInput
                      placeholder={"Select Time"}
                      multiline={false}
                      placeholderTextColor={AppColors.gray_C4C4C4}
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        styles.textInputStyle,
                      ]}
                      editable={false}
                      // ref={refValue}
                      onSubmitEditing={() => {}}
                      onChangeText={setSelectTime}
                      keyboardType="default"
                      secureTextEntry={false}
                      value={selectTime}
                    />
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          </View>
        </View>
      </ScrollView>

      <View style={styles.bottomButtonBGView}>
        {/* Back Button */}
        <TouchableOpacity
          style={{
            height: 40,
            paddingHorizontal: 50,
            borderColor: AppColors.appViolentColor_6D08C3,
            borderWidth: 1,
            justifyContent: "center",
            alignItems: "center",
            borderRadius: 10,
          }}
          onPress={() => {
            setShowVerification(true);
          }}
        >
          <Text
            style={[AppFontStyle.BOLD_ANYBODY_12, { color: AppColors.white }]}
          >
            Back
          </Text>
        </TouchableOpacity>

        {/* Submit Button */}
        <TouchableOpacity
          style={{
            height: 40,
            paddingHorizontal: 50,
            backgroundColor: AppColors.appViolentColor_6D08C3,
            justifyContent: "center",
            alignItems: "center",
            borderRadius: 10,
          }}
          onPress={() => {
            // setShowPurchaseSuccess(true);
            paymentRequestRefundAPI(() => {
              setShowPurchaseSuccess(true);
            });
          }}
        >
          <Text
            style={[AppFontStyle.BOLD_ANYBODY_12, { color: AppColors.white }]}
          >
            Submit
          </Text>
        </TouchableOpacity>
      </View>
      {
        <DateTimePickerModal
          showModal={showDatePicker}
          setShowModal={setShowDatePicker}
          selectedDate={(date) => {
            setDateTimeInput(date);
            const dateData = new Date(date);

            if (selectDateTimePressed) {
              const formatedStartDate = dayjs(dateData).format("DD/MM/YYYY");
              setSelectDate(formatedStartDate);
            } else {
              const formatedStartTime = dayjs(dateData).format("HH:mm");
              setSelectTime(formatedStartTime);
            }
          }}
          timePicker={true}
        />
      }

      {showPurchaseSuccess && (
        <PurchaseSuccess
          showModal={showPurchaseSuccess}
          setShowModal={setShowPurchaseSuccess}
        />
      )}

      {showVerification && (
        <VerificationModal
          showModal={showVerification}
          setShowModal={setShowVerification}
        />
      )}

      {<ShowLoader showIndicater={showLoader} />}
    </View>
  );

  async function paymentRequestRefundAPI(successData) {
    setShowLoader(true);

    const refundDetails = {
      userID: userData.username,
      eventName: eventName,
      amount: amount,
      phoneNumber: phone,
      email: email,
      eventDateTime: `${selectDate} ${selectTime}`,
      refundMethod: arrRefundMethod.find((item) => item.isSelected === true)
        .method,
      refundReason: arrSelectReason.find((item) => item.isSelected === true)
        .reason,
    };

    try {
      const data = await fetchPaymentRequestRefund(
        userData.AccessToken,
        refundDetails
      );
      setShowLoader(false);

      if (data.statusCode === 200) {
        toast.success("Refund Requested Successfully");
        successData(refundDetails);
      } else {
        toast.error(
          data.error || "An error occurred during the refund request"
        );
      }
    } catch (error) {
      setShowLoader(false);

      toast.error(error.message);
    }
  }
};

export default RefundRequestScreen;

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: "transparent",
      paddingHorizontal: "3.5%",
      paddingTop: "2.5%",
    },
    separaterStyle: {
      height: 2,
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      marginVertical: 15,
    },
    dragDropView: {
      height: 105,
      backgroundColor: AppColors.appBlackColor_1e1e1e,
      borderRadius: 10,
      padding: 10,
      alignItems: "center",
      flexDirection: "row",
      justifyContent: "space-between",
      gap: 10,
    },
    textInputStyle: {
      backgroundColor: AppColors.appBlackColor_1e1e1e,
      borderRadius: 10,
      padding: 10,
      color: AppColors.gray_C3C3C3,
      height: 54,
      alignItems: "center",
    },
    infoViewStyle: {
      flexDirection: "row",
      justifyContent: "space-between",
      // width: "80%",
      gap: 15,
    },
    bottomButtonBGView: {
      height: 50,
      width: "80%",
      paddingRight: 17,
      justifyContent: "flex-end",
      flexDirection: "row",
      gap: 15,
      marginVertical: 20,
    },
    inputWrapper: {
      flex: 1,
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      paddingHorizontal: 12,
      borderRadius: 10,
    },
    btnSubmitStyle: {
      height: 40,
      paddingHorizontal: 50,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      justifyContent: "center",
      alignItems: "center",
      borderRadius: 10,
    },
    deviceflexDirection: {
      flexDirection: "row",
    },
  },
  {
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      separaterStyle: {
        height: 2,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        marginVertical: 10,
      },
      dragDropView: {
        height: 105,
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        borderRadius: 10,
        padding: 10,
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "space-between",
        gap: 10,
      },
      infoViewStyle: {
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
        gap: 15,
      },
      bottomButtonBGView: {
        height: 50,
        width: "100%",
        justifyContent: "flex-end",
        flexDirection: "row",
        gap: 15,
        marginVertical: 20,
      },
      inputWrapper: {
        flex: 1,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        paddingHorizontal: 12,
        borderRadius: 10,
      },
      btnSubmitStyle: {
        height: 40,
        paddingHorizontal: 50,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 10,
      },
      deviceflexDirection: {
        flexDirection: "column",
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      separaterStyle: {
        height: 2,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        marginVertical: 10,
      },
      dragDropView: {
        height: 105,
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        borderRadius: 10,
        padding: 10,
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "space-between",
        gap: 10,
      },

      infoViewStyle: {
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
        gap: 15,
      },
      bottomButtonBGView: {
        height: 50,
        width: "100%",
        justifyContent: "flex-end",
        flexDirection: "row",
        gap: 15,
        marginVertical: 20,
      },
      inputWrapper: {
        flex: 1,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        paddingHorizontal: 12,
        borderRadius: 10,
      },
      btnSubmitStyle: {
        height: 40,
        paddingHorizontal: 50,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 10,
      },
      deviceflexDirection: {
        flexDirection: "row",
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      separaterStyle: {
        height: 2,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        marginVertical: 10,
      },
      dragDropView: {
        height: 105,
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        borderRadius: 10,
        padding: 10,
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "space-between",
        gap: 10,
      },

      infoViewStyle: {
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
        gap: 15,
      },
      bottomButtonBGView: {
        height: 50,
        width: "100%",
        justifyContent: "flex-end",
        flexDirection: "row",
        gap: 15,
        marginVertical: 20,
      },
      inputWrapper: {
        flex: 1,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        paddingHorizontal: 12,
        borderRadius: 10,
      },
      btnSubmitStyle: {
        height: 40,
        paddingHorizontal: 50,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 10,
      },
      deviceflexDirection: {
        flexDirection: "column",
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      separaterStyle: {
        height: 2,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        marginVertical: 10,
      },
      dragDropView: {
        height: 105,
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        borderRadius: 10,
        padding: 10,
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "space-between",
        gap: 10,
      },

      infoViewStyle: {
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
        gap: 15,
      },
      bottomButtonBGView: {
        height: 50,
        width: "100%",
        justifyContent: "flex-end",
        flexDirection: "row",
        gap: 15,
        marginVertical: 20,
      },
      inputWrapper: {
        flex: 1,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        paddingHorizontal: 12,
        borderRadius: 10,
      },
      btnSubmitStyle: {
        height: 40,
        paddingHorizontal: 50,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 10,
      },
      deviceflexDirection: {
        flexDirection: "column",
      },
    },
  }
);
